import {Component, Input, OnInit} from '@angular/core';
import {ComGoalEmployeeJobModel} from '../../../app/model/com-goal-employee-job.model';
import {CatalogModel} from '../../../app/model/other-catalogs-models';
import {CatFeeEmployeejobModel} from '../../../app/model/cat-fee-employee-job-model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {catchError, tap} from 'rxjs/operators';
import {forkJoin, of, throwError} from 'rxjs';
import {CatGoalEmployeeJobFisofoService} from 'src/oldApp//services/cat-goal-employee-job-fisofo.service';

@Component({
  selector: 'app-modal-cat-goal-employee-job-fisofo',
  templateUrl: './modal-cat-goal-employee-job-fisofo.component.html',
  styleUrls: ['./modal-cat-goal-employee-job-fisofo.component.css']
})
export class ModalCatGoalEmployeeJobFisofoComponent implements OnInit {

  @Input() goal:ComGoalEmployeeJobModel;
  @Input() page:string;
  @Input() mode:string;
  @Input() goals:ComGoalEmployeeJobModel[]=[];

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;

  // catalogos
  public employeeJobCatalog:CatalogModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  /////////////////
  constructor(
    private comGoalEmployeeJobService:CatGoalEmployeeJobFisofoService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  updateEmployeeJob=()=> {

  }
  updateMinGoal=e=> this.goal.minGoal=Number(e);
  updateMaxGoal=e=> this.goal.maxGoal=Number(e);
  updateCommission=e=> this.goal.commission=Number(e);
  toggleActive=()=> this.goal.activeId=!this.goal.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.minGoalError()) errors.push('Necesita capturar una meta mínima.');
    if(this.maxGoalError()) errors.push('Necesita capturar una meta máxima.');
    if(this.validateMinMaxGoal()) errors.push('Necesita capturar una meta máxima mayor a la meta mínima.');
    if(this.existsError()) errors.push('La meta para el puesto seleccionado, ya existe!');
    //if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comGoalEmployeeJobService.save(this.goal)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  employeeJobError=()=> !this.goal.employeeJobId;
  minGoalError=()=> this.goal.minGoal==0|| !this.goal.minGoal;
  maxGoalError=()=> this.goal.maxGoal==0|| !this.goal.maxGoal;
  commissionError=()=> this.goal.commission==0|| !this.goal.commission;
  validateMinMaxGoal=()=> this.goal.maxGoal<this.goal.minGoal;
  existsError=()=>{
    let exists = false;
    let goalsFiltered = this.goals.filter(ca => ca.employeeJobId === this.goal.employeeJobId);
    if(this.mode === "create" && goalsFiltered.length > 0){
      exists = true;
    }
    return exists;
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.comGoalEmployeeJobService.getEmployeeJobs(),
    )
      .pipe(
        tap(([empJobResp]:[any])=> {
          if(empJobResp) {
            this.employeeJobCatalog = empJobResp.data
              .filter(item => item.employeeJobId === 2 || item.employeeJobId === 3 || item.employeeJobId === 4)
              .map(function(row){
              delete row.status;
              delete row.createdDate;
              delete row.updatedDate;
              row.id = row.employeeJobId;
              return row
            });
            console.log(">> this.employeeJobCatalog=", this.employeeJobCatalog);
            this.viewStatus=1;
            if(this.mode === "edit"){
              this.updateEmployeeJob();
            }
          }
          else throwError;
        }),
        catchError(error=> {
          console.log(error);
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
        })
      )
      .subscribe();
  }

}
